import { ALERTA, ENUM_TIPO_PESSOA, MSG_CNPJ_INCORRETO, MSG_CPF_INCORRETO, TIPO_DOCUMENTO } from 'utils/consts';
import { fetchNotificationApp } from 'store/fetchActions/fetchApp';

export const optionsTipoPessoa = [
  {
    value: ENUM_TIPO_PESSOA.fisica.id,
    label: ENUM_TIPO_PESSOA.fisica.descricao,
  },
  {
    value: ENUM_TIPO_PESSOA.juridica.id,
    label: ENUM_TIPO_PESSOA.juridica.descricao,
  },
];

export const widthCamposDefault = {
  xs: 24,
  sm: 16,
  md: 8,
  lg: 8,
  xl3: 3,
  xl4: 4,
  xl5: 5,
};

export const getFiltroInicial = filtroInicial => {
  const requerimentoData = {
    dataInicio: filtroInicial?.dataAbertura?.dataInicio || '',
    dataFim: filtroInicial?.dataAbertura?.dataFim || '',
  };
  const encerramentoData = {
    dataInicio: filtroInicial?.dataEncerramento?.dataInicio || '',
    dataFim: filtroInicial?.dataEncerramento?.dataFim || '',
  };

  return {
    dataAbertura: requerimentoData,
    dataEncerramento: encerramentoData,
    protocolo: filtroInicial?.protocolo || '',
    assuntoId: filtroInicial?.assuntoId || '',
    statusId: filtroInicial?.statusId || '',
    solicitacaoId: filtroInicial?.solicitacaoId || '',
    tipoPessoaId: filtroInicial?.tipoPessoaId || '',
    setorId: filtroInicial?.setorId || [],
    atendenteId: filtroInicial?.atendenteId || '',
    numeroDocumento: filtroInicial?.numeroDocumento || '',
  };
};

export const montarSetoresAtendentes = setores => {
  const todosSetores = setores?.map(setor => {
    return setor.id !== 0
      ? {
          value: setor?.id,
          label: setor?.nome,
        }
      : null;
  });
  const len = todosSetores.length - 1;
  return todosSetores.slice(0, len);
};

export const montarFiltroSetores = setores => {
  let url = '?';
  setores?.forEach(setor => (url += `&filtroSetorId=${setor}`));
  return url;
};

export const validaDocumento = (numeroDocumento, tipoDocumentoNome) => {
  if (tipoDocumentoNome) {
    if (tipoDocumentoNome === TIPO_DOCUMENTO.CPF && numeroDocumento?.length !== 14) {
      fetchNotificationApp(MSG_CPF_INCORRETO, '', ALERTA.AVISO, 'bottomRight');
      return true;
    }
    if (tipoDocumentoNome === TIPO_DOCUMENTO.CNPJ && numeroDocumento?.length !== 18) {
      fetchNotificationApp(MSG_CNPJ_INCORRETO, '', ALERTA.AVISO, 'bottomRight');
      return true;
    }
  }
  return false;
};
